<script>
	import { onMount } from "svelte";
	import { apiData, nfts } from './store.js';
	import { fade } from "svelte/transition";

	let loading = true;
	
	// Create the function for API Call 
	async function fetchData(all, apiUrl, options) {
		const newData = await fetch(apiUrl, options)
		.then(response => response.json())

		all = all.concat(newData);

		let url = new URL(apiUrl);

  		// Check next API url is empty or not, if not empty call the above function 
  		if('nextPage' in newData && newData.nextPage != '' && newData.nextPage != null) {
  			return await fetchData(all, apiUrl, {
  				"body": JSON.stringify({token: newData.nextPage}),
  				"method": "POST",
  			});
  		} else if('pagination' in newData && newData.pagination.nextPage != '' && newData.pagination.nextPage != null) {
  			return await fetchData(all, apiUrl.replace('&page='+newData.pagination.currentPage,'&page='+newData.pagination.nextPage), {});
		} else if(url.searchParams.get("q") != null && newData.results.data.length > 0) {
			let q = JSON.parse(url.searchParams.get("q"));
			q.$skip+=20;
			url.searchParams.set("q",JSON.stringify(q));
 			return await fetchData(all, url, {});
  		} else {
  			return all;
  		} 
  	}

  	const byteSize = str => new Blob([str]).size;

  	function isPublicKey(str) {
  		if (str === undefined || byteSize(str) <= 32 ) { return false; }

		var code, i, len;

		for (i = 0, len = str.length; i < len; i++) {
		code = str.charCodeAt(i);
		if (!(code > 47 && code < 58) && // numeric (0-9)
		    !(code > 64 && code < 91) && // upper alpha (A-Z)
		    !(code > 96 && code < 123)) { // lower alpha (a-z)
		  return false;
		}
		}
		return true;
	}

	function getSceneNumber(attributes) {
		const attribute = attributes.find(attr => (attr.name || attr.trait_type) === "scene number");
		return attribute ? String(attribute.value).padStart(4, '0') : null;
	}

	function getTimeline(attributes) {
		const attribute = attributes.find(attr => (attr.name || attr.trait_type) === "timeline");
		return attribute ? attribute.value : null;
	}

	function getTimelinesMerged(attributes) {
		const attribute = attributes.find(attr => (attr.name || attr.trait_type) === "timelines merged");
		return attribute ? parseInt(attribute.value) : 0;
	}

  	onMount(async () => {

  		let NFTs = [];

		// Magic Eden data
		await fetchData([],"https://pyro-proxy.herokuapp.com/https://api-mainnet.magiceden.dev/rpc/getListedNFTsByQuery?q=%7B%22%24match%22%3A%7B%22collectionSymbol%22%3A%22infinity_labs%22%7D%2C%22%24sort%22%3A%7B%22takerAmount%22%3A1%7D%2C%22%24skip%22%3A0%2C%22%24limit%22%3A20%2C%22status%22%3A%5B%5D%7D")
		.then(data => {
			data.forEach((data) => {
				if ('results' in data) {
					NFTs = NFTs.concat(data.results.data.map(nft => {
						return ({
							"market": "magiceden.io",
							"name": nft.title,
							"scene": getSceneNumber(nft.attributes),
							"timeline": getTimeline(nft.attributes),
							"img": 'https://scene-sniper.strange.tools/images/'+getSceneNumber(nft.attributes)+'.webp',
							"href": 'https://magiceden.io/item-details/'+nft.mintAddress,
							"price": nft.price,
							"token": nft.mintAddress,
							"merged": getTimelinesMerged(nft.attributes)
						})
					}));
				}
			})
		}).catch(error => {
			console.log(error); 
		});

		// Solonart.io data
		await fetchData([],'https://api-v2.solanart.io/nfts?collection_id=infinitylabs&page=0&limit=25&attributes=[]&query=&listed=true&order_by=price&direction=ASC&contract_ids[]=solanart-v1&contract_ids[]=solanart-v2', {}).then(data => {
			data.forEach((data) => {
				if ('items' in data) {

					// Filter out duplicate tokens
					var filterItems = data.items.filter(item => !NFTs.find(nft => nft.token == item.tokenAddress));

					NFTs = NFTs.concat(filterItems.map(nft => ({
						"market": "solanart.io",
						"name": nft.name,
						"scene": getSceneNumber(nft.attributes),
						"timeline": getTimeline(nft.attributes),
						"img": 'https://scene-sniper.strange.tools/images/'+getSceneNumber(nft.attributes)+'.webp',
						"href": 'https://solanart.io/nft/'+nft.tokenAddress,
						"price": nft.price,
						"token": nft.tokenAddress,
						"merged": getTimelinesMerged(nft.attributes)
					})));
				}
			})
		}).catch(error => {
			console.log(error); 
		});
			
		// Alpha.art data
		await fetchData([],'https://apis.alpha.art/api/v1/collection', {
			"body": "{\"collectionId\":\"infinitylabs\",\"orderBy\":\"PRICE_LOW_TO_HIGH\",\"status\":[\"BUY_NOW\"],\"traits\":[]}",
			"method": "POST",
		}).then(data => {
			data.forEach((data) => {
				if ('tokens' in data) {

					// Filter out duplicate tokens
					var filterItems = data.tokens.filter(item => !NFTs.find(nft => nft.token == item.mintId));

					NFTs = NFTs.concat(filterItems.map(nft => ({
						"market": "alpha.art",
						"name": nft.title,
						"scene": nft.title.split("#")[1].substr(0,4),
						"timeline": nft.title.split("#")[2].substr(0,1),
						"img": 'https://scene-sniper.strange.tools/images/'+nft.title.split("#")[1].substr(0,4)+'.webp',
						"href": 'https://alpha.art/t/'+nft.mintId,
						"price": (nft.price/1000000000),
						"token": nft.mintId,
						"merged": 1
					})));	
				}
			})
		}).catch(error => {
			console.log(error); 
		});

		apiData.set(NFTs);

		loading = false;
	});

	let marketIcons = {
		'exchange.art': 'https://exchange.art/favicon.ico',
		'magiceden.io': '/images/magiceden.ico',
		'ftx.us': 'https://ftx.us/favicon.ico',
		'alpha.art': 'https://alpha.art/favicon.ico',
		'solanart.io': 'https://solanart.io/favicon-32x32.png',
	};
	let	menuShow = false;

	let	searchScene = false; 
	let	walletSearch = false; 
	let searchNumberOfTimelines = 8;
	let sceneNumber;	
	let publicKey;
	let walletScenes = [];

	async function hashchange() {
		// the poor man's router!
		const hash = window.location.hash.slice(1);
		if(hash === '' || hash === '/' || hash === '8') {
			searchNumberOfTimelines = 8;
			searchScene=false;
			walletSearch=false;
			menuShow=false;
		}else if(['2','3','4','5','6','7'].includes(hash)) {
			searchNumberOfTimelines = parseInt(hash, 10);
			searchScene=false;
			walletSearch=false;
			menuShow=false;
		}else if(hash.slice(0,6) === 'search') {
			searchScene=true;
			walletSearch=false;
			menuShow=false;

			if(hash.length > 7) {
				sceneNumber = parseInt(hash.slice(7,hash.length), 10);
			}

		}else if(hash.slice(0,6) === 'wallet') {
			searchScene=false;
			walletSearch=true;
			menuShow=false;

			if(hash.length > 7 && isPublicKey(hash.slice(7,hash.length)) ) {
				publicKey = hash.slice(7,hash.length);
			}
		}
	}

	onMount(hashchange);

	// On page load or when changing themes, best to add inline in `head` to avoid FOUC
	// Sloppy code is sloppy, needs a refactor
	if (localStorage.getItem("theme") === null) {
		if (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			document.documentElement.classList.add('dark')
			localStorage.theme = 'dark'
		} else {
			document.documentElement.classList.remove('dark')
			localStorage.theme = 'light'
		}
	} else {
		if (localStorage.theme === 'dark') {
			document.documentElement.classList.add('dark')
		} else {
			document.documentElement.classList.remove('dark')
		}
	}

	function toggleDarkMode(){
		if (localStorage.theme !== 'dark') {
			document.documentElement.classList.add('dark')
			localStorage.theme = 'dark'
		} else {
			document.documentElement.classList.remove('dark')
			localStorage.theme = 'light'
		}
	}

	function connectWallet(){
		// Connect to your Phantom Wallet 
		// https://docs.phantom.app/integrating/establishing-a-connection
		if ("solana" in window) {
			window.solana.connect();
			window.solana.on("connect", async () => {
				// Get your publickey from your connected Phantom Wallet
				publicKey = window.solana.publicKey.toString();
			});
		}
	}

	async function getWalletScenes(){

		// Check if publickey is valid
		if(!isPublicKey(publicKey)) {
			return false;
		}

		// Magic Eden API to get NFTS
		await fetch("https://pyro-proxy.herokuapp.com/https://api-mainnet.magiceden.dev/v2/wallets/"+publicKey+"/tokens")
		.then(response => response.json())
		.then(data => {
			walletScenes = walletScenes.concat(data.filter(nft => nft.collection === "infinity_labs").map(nft => nft.name.split("#")[1].substr(0,4)));
		}).catch(error => {
			console.log(error); 
		});
	}

	$: publicKey, getWalletScenes();

	$: filteredNFTS = $nfts.filter(nft => {
		if (searchScene) {
			return nft.scene == sceneNumber;
		} else if (walletSearch) {
			return walletScenes.length !== 0 && walletScenes.includes(nft.scene);
		} else { 
			return nft.totalTimelines === searchNumberOfTimelines;
		}
	});
</script>

	<svelte:window on:hashchange={hashchange}/>

	<div>
		<nav class="bg-blue-1000 border-b border-solid border-black"> 
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div class="flex items-center justify-between h-16 ">
					<div class="flex items-center">
						<div class="flex-shrink-0">
							<img class="h-10 w-10 rounded-full" alt="" src="data:image/png;base64,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">
						</div>
						<div class="hidden md:block">
							<div class="ml-10 flex items-baseline space-x-4">
								<a href="#8" class="text-gray-200 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium">Multiple timelines</a>
								<a href="#search" class="text-gray-200 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-sm font-medium">Search a scene</a>
								<a href="#wallet" class="text-gray-200 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-sm font-medium">Wallet search</a>
							</div>
						</div>
					</div>
					<div class="hidden md:block">
						<div class="ml-4 flex items-center md:ml-6">
							<button type="button" class="text-gray-200 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium" on:click={toggleDarkMode}>
								<span class="sr-only">Toggle dark mode</span>
								<svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-5 w-5 block dark:hidden" viewBox="0 0 20 20" fill="currentColor">
									<path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
								</svg>
								<svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-5 w-5 hidden dark:block" viewBox="0 0 20 20" fill="currentColor">
									<path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
								</svg>
							</button>
						</div>
					</div>
					<div class="-mr-2 flex md:hidden">
						<button type="button" class="bg-gray-800 mr-2 inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-gray-700 focus:outline-none" aria-controls="mobile-menu" aria-expanded="false" on:click={toggleDarkMode}>
							<span class="sr-only">Toggle dark mode</span>
							<svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-5 w-5 block dark:hidden" viewBox="0 0 20 20" fill="currentColor">
								<path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
							</svg>
							<svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-5 w-5 hidden dark:block" viewBox="0 0 20 20" fill="currentColor">
								<path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
							</svg>
						</button>
						<button type="button" class="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-gray-700 focus:outline-none" aria-controls="mobile-menu" aria-expanded="false" on:click={() => menuShow = !menuShow}>
							<span class="sr-only">Open main menu</span>

							<svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
							</svg>

							<svg class="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
							</svg>
						</button>
					</div>
				</div>
			</div>
			<!-- Mobile menu, show/hide based on menu state. -->
			<div class="md:hidden {menuShow ? '':'hidden'}">
				<div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
					<a href="#8" class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">Multiple timelines</a>
					<a href="#search" class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">Search a scene</a>
					<a href="#wallet" class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">Wallet search</a>
				</div>
			</div>
		</nav>

		<header>
			<div class="max-w-7xl mx-auto mt-4 py-6 px-4 sm:px-6 lg:px-8">
				{#if searchScene}
				<h1 class="text-2xl md:text-3xl font-bold mb-2">Search a scene</h1>
			
                <div class="mt-1 flex inline-flex rounded-full shadow-sm">
                  <span class="inline-flex items-center px-3 rounded-l-full border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                    #
                  </span>
                  <input bind:value={sceneNumber} on:input="{() => history.pushState(null, null, '#search/'+(sceneNumber !==null ? sceneNumber : ''))}" type="number" placeholder="Scene number" class="appearance-none border rounded-none rounded-r-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                </div>
	     
				{:else if walletSearch}
				<h1 class="text-2xl md:text-3xl font-bold mb-2">Wallet search</h1>
				<p class="text-sm mb-4">
					Sorted by number of timelines (low-high)
				</p>
    
                <input bind:value={publicKey} on:input="{() => history.pushState(null, null, '#wallet/'+(publicKey !==null ? publicKey : ''))}" type="input" placeholder="Wallet address" class="appearance-none border rounded-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline w-full lg:w-1/2 mb-4">

                <div class="hidden">
                	<button on:click={connectWallet} type="button" class="flex items-center px-4 py-2 space-x-3 text-gray-600 transition-colors duration-200 transform border rounded-full dark:text-gray-200 dark:border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none">
						<img src="https://raw.githubusercontent.com/solana-labs/wallet-adapter/master/packages/wallets/icons/phantom.svg" alt="Phantom icon" class="w-5 h-5">
						<span>Get wallet address with Phantom</span>
					</button>
                </div>
				
				{:else}
				<h1 class="text-2xl md:text-3xl font-bold mb-2">Scenes with multiple timelines for sale</h1>
				<p class="text-sm mb-4">
					Sorted by the total price (low-high)
				</p>
				<div class="overflow-x-scroll scrolling-touch max-w-full md:overflow-hidden">
                    <nav class="flex items-center mt-1 md:mt-0">
                        {#each [8,7,6,5,4,3,2] as timeline}
						<a href="#{timeline}" class="flex items-center px-4 py-2 space-x-3 text-gray-600 transition-colors duration-200 transform border rounded-full dark:text-gray-200 dark:border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none whitespace-nowrap mr-2 {searchNumberOfTimelines === timeline ? 'bg-gray-100 dark:bg-gray-700' : ''}">
							{timeline} timelines
						</a>
						{/each}
                    </nav>
                </div>
				{/if}
			</div>
		</header>
		<main>
			<div class="max-w-7xl mx-auto mt-2 px-4 sm:px-6 lg:px-8">
				<section>
					<div class="flex flex-wrap -mx-4">
						{#each filteredNFTS as nft, index (nft)}
						<div class="w-full md:w-1/2 lg:w-1/3 px-4 mb-8" in:fade out:fade="{{ duration:(searchScene?0:400)}}">
							<div class="rounded overflow-hidden bg-white dark:bg-blue-1000 shadow-lg">
								<img class="w-full" src="{nft.img}" alt="{nft.scene}" width="384" height="384">
								<div class="flex px-4 py-4">
									<div class="w-1/2">
										<h2 class="block font-bold text-xl mb-2">Scene #{nft.scene}</h2>
									</div>
									<div class="w-1/2 flex justify-end">
										<div class="inline-block bg-indigo-700 rounded-full px-3 py-2 text-sm font-semibold text-white mr-2 mb-2">
											<img alt="SOL" loading="lazy" src="https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/solana/info/logo.png" class="inline-block h-6 w-6 rounded-full mr-2">{nft.totalPrice.toFixed(2)} SOL
										</div>
									</div>
								</div>

								<div class="px-4 pb-2 mb-2">
									<h2 class="font-bold text-l mb-2">Timelines</h2>
									<div class="flex flex-wrap flex-row">
										{#each nft.timelines as timeline}
										<a target="_blank" href="{timeline.href}" class="flex justify-center items-center bg-gray-200 hover:bg-gray-100 dark:bg-indigo-900 dark:hover:bg-indigo-800 rounded-full px-3 py-1 text-tiny text-gray-700 dark:text-white mr-2 mb-2" style="order:{timeline.timeline}">
											<img alt="{timeline.market}" loading="lazy" src="{marketIcons[timeline.market]}" class="inline-block h-4 w-4 rounded-full mr-2">
											#{timeline.timeline} ({timeline.merged}) - {timeline.price.toFixed(2)} SOL
										</a>
										{/each}
									</div>
								</div>
							</div>
						</div>
						{:else}
						<div class="w-full px-4 mb-8">
							{#if loading }
							<p>Loading...</p>
							{:else}
							<p>No results found</p>
							{/if}
						</div>
						{/each}
					</div>
				</section>
			</div>
		</main>
		<footer>
			<div class="py-6 text-center">
				<p class="flex items-center justify-center text-sm sm:text-base">
					Build with&nbsp;<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-current w-6 h-6 text-red-700"><path d="M2 8.40001C1.99975 6.95035 2.58239 5.56146 3.61681 4.54584C4.65124 3.53022 6.05058 2.97317 7.5 3.00001C9.21732 2.99089 10.856 3.71919 12 5.00001C13.144 3.71919 14.7827 2.99089 16.5 3.00001C17.9494 2.97317 19.3488 3.53022 20.3832 4.54584C21.4176 5.56146 22.0002 6.95035 22 8.40001C22 13.756 15.621 17.8 12 21C8.387 17.773 2 13.76 2 8.40001Z" fill="currentColor"></path></svg>&nbsp;by&nbsp;<a href="https://twitter.com/KoenRijpstra" target="_blank" class="text-blue-500 hover:underline">Koen</a>
				</p>
			</div>
		</footer>
	</div>

	<style lang="postcss" global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
</style>